export default [
  {
    key: "main",
    tKey: "pages_main",
    path: "/",
    exact: true,
  },
  {
    key: "deliverNew",
    tKey: "pages_deliverNew",
    path: "/deliverNew",
  },
  {
    key: "deliveries",
    tKey: "pages_deliveries",
    path: "/deliveries",
  },
  {
    key: "userData",
    tKey: "pages_userData",
    path: "/user-data",
  },
  {
    key: "approvals",
    tKey: "pages_approvals",
    path: "/approvals",
  },
];

export const ADMIN_PAGES = [
  {
    key: "main",
    tKey: "pages_main",
    path: "/",
    exact: true,
  },
  {
    key: "deliveries",
    tKey: "pages_assets",
    path: "/deliveries/",
  },
  {
    key: "campaigns",
    tKey: "pages_campaigns",
    path: "/campaigns",
  },
  {
    key: "userData",
    tKey: "pages_userData",
    path: "/user-data",
  },
  {
    key: "approvals",
    tKey: "pages_approvals",
    path: "/approvals",
  },
];

export const SUPERADMIN_PAGES = [
  {
    key: "main",
    tKey: "pages_main",
    path: "/",
    exact: true,
  },
  {
    key: "deliveries",
    tKey: "pages_assets",
    path: "/deliveries/",
  },
  {
    key: "campaigns",
    tKey: "pages_campaigns",
    path: "/campaigns",
  },
  {
    key: "setup",
    tKey: "pages_setup",
    path: "/setup",
  },
  {
    key: "userData",
    tKey: "pages_userData",
    path: "/user-data",
  },
  {
    key: "approvals",
    tKey: "pages_approvals",
    path: "/approvals",
  },
];

export const SETUP_PAGES = [
  {
    key: "digital-sizes",
    tKey: "digital_sizes",
    path: "/setup/digital-sizes",
  },
  {
    key: "digital-services",
    tKey: "digital_services",
    path: "/setup/digital-services",
  },
  {
    key: "print-sizes",
    tKey: "print_sizes",
    path: "/setup/print-sizes",
  },
  {
    key: "print-services",
    tKey: "print_services",
    path: "/setup/print-services",
  },
  {
    key: "user-management",
    tKey: "user_management",
    path: "/setup/user-management",
  },
  {
    key: "approvers",
    tKey: "approvers",
    path: "/setup/approvers",
  },
  {
    key: "media-agencies",
    tKey: "media_agencies",
    path: "/setup/media-agencies",
  },
];

export const CAMPAIGN_PAGES = [
  {
    key: "campaigns",
    tKey: "active_campaigns",
    path: "/campaigns",
  },
  {
    key: "inactive-campaigns",
    tKey: "inactive_campaigns",
    path: "/campaigns/inactive-campaigns",
  },
];

export const APPROVAL_PAGES = [
  {
    key: "approvals",
    tKey: "approved_campaigns",
    path: "/approvals",
  },
  {
    key: "unresolved-campaigns",
    tKey: "unresolved_campaigns",
    path: "/approvals/unresolved-campaigns",
  },
];
